module.exports = __webpack_public_path__ + "img/bz.81f2d641.svg";